module.exports = __webpack_public_path__ + "static/media/1350_Cart_Medical_purchaseHL.e1c4c7e0.png";